<div mat-dialog-content>
    <h2>Merge budget {{ data.budget?.budgetNr }} into an existing Project</h2>
    <div style="overflow-y: auto; max-height: 300px;">

        <app-project-selector-component style="min-width: 220px"
                                        [required]="true"
                                        [exportOnly]="data.budget?.export !== undefined"
                                        [importOnly]="data.budget?.export === undefined"
                                        (budgetChange)="onBudgetChange($event)">
        </app-project-selector-component>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" mat-dialog-close>Close</button>
    <button mat-flat-button color="primary" (click)="submit()">Submit</button>
</div>